import { isFlutterApp, getFlutterLocation } from './flutterBridge'

export const getBrowserName = () => {
  if (typeof navigator === 'undefined') return 'Unknown'
  const userAgent = navigator.userAgent
  let browserName = 'Chrome'

  if (userAgent.indexOf('Firefox') > -1) {
    browserName = 'Firefox'
  } else if (userAgent.indexOf('Trident') > -1) {
    browserName = 'Internet Explorer'
  } else if (userAgent.indexOf('Edge') > -1 || userAgent.indexOf('Edg') > -1) {
    browserName = 'Edge'
  } else if (userAgent.indexOf('Chrome') > -1) {
    browserName = 'Chrome'
  } else if (userAgent.indexOf('Safari') > -1) {
    browserName = 'Safari'
  }

  return browserName
}

export const getLatLong = async () => {
  if (isFlutterApp()) {
    try {
      const flutterLoc = await getFlutterLocation()
      return {
        coords: {
          latitude: flutterLoc.lat,
          longitude: flutterLoc.lon
        },
        deviceData: {
          deviceName: flutterLoc.deviceName || 'Flutter Device',
          imeiNumber: flutterLoc.imeiNumber || '',
          batteryHealth: typeof flutterLoc.batteryHealth === 'number' ? flutterLoc.batteryHealth : 100,
          accuracy: flutterLoc.accuracy || 10
        }
      }
    } catch (e) {
      console.warn('📱 [FlutterBridge] Falling back to browser geolocation:', e)
    }
  }

  return new Promise((resolve, reject) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
      reject(new Error('Geolocation is not supported by your browser'))
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            coords: {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            },
            deviceData: {
              userAgent: navigator.userAgent,
              deviceName: getBrowserName()
            }
          })
        },
        (error) => {
          reject(error)
        },
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 10000 }
      )
    }
  })
}

export const formatTimeSeconds = (totalSeconds) => {
  if (!totalSeconds || isNaN(totalSeconds)) return '00:00:00'
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = Math.floor(totalSeconds % 60)

  const pad = (n) => (n < 10 ? '0' + n : n)
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
}

export const convertNumberToAmount = (amount) => {
  if (!amount && amount !== 0) return '0'
  return new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 2
  }).format(amount)
}

export const maskPhoneNumber = (phone) => {
  if (!phone) return ''
  const str = String(phone).trim()
  if (str.length < 4) return str
  return str.slice(0, 2) + '******' + str.slice(-2)
}
